import { CommonModule } from '@angular/common';
import { Component, computed, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class SpinnerComponent {
  @Input()
  color = '#1100db';
  @Input()
  overlay = false;
  @Input()
  size = '48px';
  @Input()
  thickness = '4px';
  @Input()
  text!: string;

  spinnerSize = computed(() => `calc(${this.size} + 16px)`);
}
